import { AppBar, Avatar, Badge, Box, Button, Checkbox, FormControl, FormControlLabel, Grid, Grid2, IconButton, InputAdornment, MenuItem, Paper, Radio, RadioGroup, Select, Snackbar, styled, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useRef, useState } from "react";
import config from '../../config/config.js';
import dayjs from 'dayjs';
import { GoogleMap, Marker, DirectionsService } from "@react-google-maps/api";
import { useGoogleMapsLoader, LIBRARIES } from "../../utils/GoogleMapsLoader";
import { makeGetRequestToUrl } from "../commonFunc.jsx";
import { makePostRequestToUrl } from "../commonFunc.jsx";
import { TabPanel } from "@mui/lab";
import BookingTable from './BookingTable';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import { Label } from "flowbite-react";
// import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo/DemoContainer.js";
import { DateTimePicker } from "@mui/x-date-pickers";
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import SearchIcon from '@mui/icons-material/Search';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import blackSeatIcon from '../../assets/icons/blackSeat.svg';
import bagIcon from '../../assets/icons/Bag.svg';
import flightIcon from '../../assets/images/flightIcon.svg';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircleSvg from '../../assets/images/AddCircleSvg.svg';
import SubtractCircleSvg from '../../assets/images/subtractCircleSvg.svg';


function a11yProps(index){
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
      };
}
// Import LIBRARIES from centralized loader if needed
// import { LIBRARIES } from "../../utils/GoogleMapsLoader";
var constants = require('../../constant');

// Email validation function
const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};
  
const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    marginRight: theme.spacing(1),
    width:'15%',
    marginTop:'4px',
    marginBottom:'4px',
    color: '#83888E',
    '&.Mui-selected': {
      color: '#fff',
      borderRadius: '4px 4px 0 0',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
}
  
CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
const TabWithBadge = ({ label, count, isActive }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography sx={{ color: isActive ? '#fff' : '#83888E', marginRight:'12px' }}>{label}</Typography>
      <Badge
        badgeContent={count}
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: '#4B4F58',
            color: '#fff',
            borderRadius: '50%',
            minWidth: '22px',
            height: '22px',
            fontSize: '12px',
            fontWeight: 500,
          },
        }}
      />
    </Box>
);
  
const Booking  = () => {
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    const [tokenExpired, setTokenExpired] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showWaypointInput, setShowWaypointInput] = useState(false);
    const waypointRefs = useRef([]);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [startDateFilter, setStartDateFilter] = useState(dayjs().startOf('month').startOf('day'));
    const [endDateFilter, setEndDateFilter] = useState(dayjs().endOf('month').startOf('day'));
    const navigate = useNavigate();
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [rows, setRows] = useState([]);
    const [bookingTab, setBookingTab] = useState(0);
    const [piuCount, setPiuCount] = useState(0);
    const [transferzCount, setTransferzCount] = useState(0);
    const [othersCount, setOthersCount] = useState(0);
    const [adminPanelCount, setAdminPanelCount] = useState(0);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [locationsModified, setLocationsModified] = useState(false); // Track if locations have been changed after edit modal opens

    const [driversData, setDriversData] = useState([]);
    const [routeType, setRouteType] = useState('0');
    const [bookingId, setBookingId] = useState('');
    const [pickup, setPickup] = useState('');
    const [drop, setDrop] = useState('');
    const [dateTime, setDateTime] = useState(dayjs());
    const [assignDriver, setAssignDriver] = useState({driver_id: '', vehicle_make_id: '', model_name: '', vehicle_number: ''});
    const [selfRemark, setSelfRemark] = useState('');
    const [driverRemark, setDriverRemark] = useState('');
    const [customerCompanyName, setCustomerCompanyName] = useState('');
    const [customerCompanyNameError, setCustomerCompanyNameError] = useState('');

    // Error states for validation
    const [pickupError, setPickupError] = useState('');
    const [dropError, setDropError] = useState('');
    // const [distanceError, setDistanceError] = useState('');
    // const [durationError, setDurationError] = useState('');
    const [dateTimeError, setDateTimeError] = useState('');
    const [customerFirstNameError, setCustomerFirstNameError] = useState('');
    const [customerLastNameError, setCustomerLastNameError] = useState('');
    const [customerEmailError, setCustomerEmailError] = useState('');
    const [customerPhoneError, setCustomerPhoneError] = useState('');
    const [seatsError, setSeatsError] = useState('');
    const [priceError, setPriceError] = useState('');
    const [returnDateError, setReturnDateError] = useState(false);

    const isValidEmail = (email) => {
        // Basic email validation regex
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    const [customerFirstName, setCustomerFirstName] = useState('');
    const [customerLastName, setCustomerLastName] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [seats, setSeats] = useState('');
    const [paymentMode, setPaymentMode] = useState('1');
    const [price, setPrice] = useState('');
    const [extras, setExtras] = useState('');
    const [partnerPrice, setPartnerPrice] = useState('');
    const [distance, setDistance] = useState('');
    const [duration, setDuration] = useState('');
    const [tax, setTax] = useState('');
    const [noOfChildren, setNoOfChildren] = useState('');
    const [luggage, setLuggage] = useState('');
    const [flightInfo, setFlightInfo] = useState('');
    const [pickupLat, setPickupLat] = useState('');
    const [pickupLng, setPickupLng] = useState('');
    const [dropLat, setDropLat] = useState('');
    const [dropLng, setDropLng] = useState('');
    const [vehicleMakeData, setVehicleMakeData] = useState([]);
    const [editVehicleMakeId, setEditVehicleMakeId] = useState('');
    const [customerCountryCode, setCustomerCountryCode] = useState('');
    const [originalBookingData, setOriginalBookingData] = useState(null);
    const [formData, setFormData] = useState({
        paid: 0,
        // Add other form fields as needed
    });
    const [customersData, setCustomersData] = useState([]);
    const [customerNameFilter, setCustomerNameFilter] = useState('');
    const [customerCompanyNameFilter, setCustomerCompanyNameFilter] = useState('');
    const [filteredCustomerNames, setFilteredCustomerNames] = useState([]);
    const [filteredCustomerCompanyName, setFilteredCustomerCompanyName] = useState([]);
    const [showCustomerCompanyNameResults, setShowCustomerCompanyNameResults] = useState(false);
    const [showCustomerNameResults, setShowCustomerNameResults] = useState(false);
    const inputPickupRef = useRef(null);
    const inputDropRef = useRef(null);

    // Calculate time 10 minutes ago when component mounts
    const tenMinutesLater = dayjs().add(10, 'minutes');
    const [returnPickupDateTime, setReturnPickupDateTime] = useState(tenMinutesLater);
    const [returnDriver, setReturnDriver] = useState({driver_id: '', vehicle_make_id: '', model_name: '', vehicle_number: ''});
    const [returnVehicleMakeData, setReturnVehicleMakeData] = useState([]);
    const [isReturnDriverVehicleSame, setIsReturnDriverVehicleSame] = useState(false);
    const [wayPointArr, setWayPointArr] = useState([]);
    const [waypointInputValue, setWaypointInputValue] = useState('');
    const [paymentStatus, setPaymentStatus] = useState('0');
    const [bookingStatusFilter, setBookingStatusFilter] = useState('');
    const waypointInputRef = useRef(null);
    const ischange_point_to_comma = localStorage.getItem('change_point_to_comma');

    const [upcomingDate, setUpcomingDate] = useState(false);
    const [todayDate, setTodayDate] = useState(false);

    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';

    const handleOpenAddBooking = () => {
        setOpenAddModal(true);
        setOpenEditModal(false);
        setBookingId('');
        setPickup('');
        setDrop('');
        setWayPointArr([]);
        setCustomerFirstName('');
        setCustomerLastName('');
        setCustomerPhone('');
        setCustomerNameFilter('');
        setCustomerEmail('');
        setCustomerCompanyNameFilter('');
        setSeats('');
        setPaymentMode('');
        setPrice('');
        setExtras('');
        setPartnerPrice('');
        setLuggage('');
        setCustomerCountryCode('');
        setFlightInfo('');
        setDistance('');
        setDuration('');
        setTax('');
        setPickupLat('');
        setPickupLng('');
        setNoOfChildren('');
        setDropLat('');
        setDropLng('');
        setPartnerPrice('');
        setExtras('');
        setPaymentMode('1');
        setPaymentStatus('0');
        setFormData({
            paid: 0,
            // Add other form fields as needed
        });
        setRouteType('0');
        setAssignDriver({driver_id: '', vehicle_make_id: '', model_name: '', vehicle_number: ''});
        setReturnDriver({driver_id: '', vehicle_make_id: '', model_name: '', vehicle_number: ''})
        setReturnVehicleMakeData('')
        setSelfRemark('');
        setDriverRemark('');
        setDateTime(dayjs());
        setReturnPickupDateTime(dayjs().add(10, 'minutes'));
        setEditVehicleMakeId('')
        setCustomerCompanyName('');
        setCustomerCompanyNameError('');
    }
    
    const handleOpenEditBooking = (row) => {
        setOpenAddModal(true);
        setOpenEditModal(true);
        setLocationsModified(false); // Reset the flag when opening edit modal
        
        // Store the original booking data for comparison when submitting
        setOriginalBookingData({
            booking_id: row.booking_id || '',
            pickup_address: row.pickup_address || '',
            drop_address: row.drop_address || '',
            user_first_name: row.user_first_name || '',
            user_last_name: row.user_last_name || '',
            user_company_name: row.user_company_name || '',
            user_phone_number: row.user_phone_number || '',
            way_points: row.way_points || '',
            user_email: row.user_email || '',
            distance: row.distance || '',
            duration: row.duration || '',
            tax: row.tax || '',
            no_of_childrens: row.no_of_childrens || '',
            ticket_count: row.ticket_count || '',
            fare: row.fare || '',
            luggage_count: row.luggage_count || '',
            country_code: row.country_code || '',
            flight_number: row.flight_number || '',
            pickup_latitude: row.pickup_latitude || '',
            pickup_longitude: row.pickup_longitude || '',
            drop_latitude: row.drop_latitude || '',
            drop_longitude: row.drop_longitude || '',
            vehicle_make_id: row.vehicle_make_id || '',
            driver_id: row.driver_id || '',
            is_paid: row.is_paid === 1 ? 1 : 0,
            pickup_time: row.pickup_time || null,
            self_remarks: row.self_remarks || '',
            driver_remarks: row.driver_remarks || '',
            partner_fare: row.partner_fare || '',
            extra_fare: row.extra_fare || '',
            payment_mode: row.payment_mode || '',
            payment_status: row.payment_status || '',
        });
        
        // Set form fields with the current values
        setBookingId(row.booking_id || '');
        setPickup(row.pickup_address || '');
        setDrop(row.drop_address || '');
        setCustomerFirstName(row.user_first_name || '');
        setCustomerLastName(row.user_last_name || '');
        setCustomerPhone(row.user_phone_number || '');
        setCustomerNameFilter('');
        setCustomerEmail(row.user_email || '');
        setCustomerCompanyName(row.user_company_name || '');
        setDistance(row.distance);
        setDuration(row.duration || '');
        setTax(row.tax || '');
        setRouteType(row.is_two_way === 1 ? '1' : '0');
        setNoOfChildren(row.no_of_childrens || '');
        setSeats(row.ticket_count || '');
        setPrice(row.fare);
        setLuggage(row.luggage_count || '');
        setCustomerCountryCode(row.country_code || '');
        setFlightInfo(row.flight_number || '');
        setPickupLat(row.pickup_latitude || '');
        setPickupLng(row.pickup_longitude || '');
        setDropLat(row.drop_latitude || '');
        setDropLng(row.drop_longitude || '');
        setPartnerPrice(row.partner_fare || '');
        setExtras(row.extra_fare || '');
        setPaymentMode(row.payment_mode || '');
        setPaymentStatus(row.payment_status || '');
        if (Array.isArray(row.way_points) && row.way_points.length > 2) {
            setWayPointArr(row.way_points.slice(1, row.way_points.length - 1));
        } else {
            setWayPointArr([]);
        }
        // setEditVehicleMakeId(row.vehicle_make_id || '');
        setFormData({
            paid: row.is_paid === 1 ? 1 : 0,
        });
        
        setSelfRemark(row.self_remarks || '');
        setDriverRemark(row.driver_remarks || '');
        
        // Set date time if available
        if (row.pickup_time) {
            setDateTime(dayjs(row.pickup_time));
        } else {
            setDateTime(dayjs());
        }
    }
    
    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
        // Reset original booking data
        setOriginalBookingData(null);
        // Reset form fields
        setPickup('');
        setDrop('');
        setDistance('');
        setDuration('');
        setDateTime(null);
        setAssignDriver({ driver_id: '', vehicle_make_id: '', model_name: '', vehicle_number: '' });
        setReturnDriver({ driver_id: '', vehicle_make_id: '', model_name: '', vehicle_number: '' })
        setReturnVehicleMakeData('')
        setEditVehicleMakeId('');
        setCustomerFirstName('');
        setCustomerLastName('');
        setCustomerEmail('');
        setCustomerPhone('');
        setCustomerNameFilter('');
        setSeats('');
        setNoOfChildren('');
        setPrice('');
        setTax('');
        setRouteType('0');
        setLuggage('');
        setCustomerCountryCode('');
        setFlightInfo('');
        setSelfRemark('');
        setDriverRemark('');
        setBookingId('');
        setPickupLat('');
        setPickupLng('');
        setDropLat('');
        setDropLng('');
        setPartnerPrice('');
        setExtras('');
        setPaymentMode('1');
        setPaymentStatus('0');

        // Reset error states
        setPickupError('');
        setDropError('');
        // setDistanceError('');
        // setDurationError('');
        setDateTimeError('');
        setCustomerFirstNameError('');
        setCustomerLastNameError('');
        setCustomerCompanyNameError('');
        setCustomerEmailError('');
        setCustomerPhoneError('');
        setSeatsError('');
        setPriceError('');
        setIsSubmitting(false); // Reset submission state when closing the modal
    };

    const handleSnackbarClose = () => {
        showSnackbar(false);
    }

    const fetchVehicleData = async() => {
        try {
            const url = serverUrl + '/vehicle/fetch_vehicle_make';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setVehicleMakeData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchBookingsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/airport/fetch_bookings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                status: -1,
                city_id: cityFilter,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                setPiuCount(response.data.filter((row) => row.source == '1').length);
                setTransferzCount(response.data.filter((row) => row.source == '2').length);
                setOthersCount(response.data.filter((row) => row.source == '0').length);
                setAdminPanelCount(response.data.filter((row) => row.source == '-1').length);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchDriversData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/airport/fetch_drivers';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setDriversData(response.data);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchBookingsData();
    },[cityFilter, startDateFilter, endDateFilter])

    useEffect(() => {
        fetchCustomersData();
    },[cityFilter]);

    useEffect(() => {
        fetchDriversData();
        fetchVehicleData();
    },[])

    useEffect(() => {
        // Check if return pickup date is before the original date
        if (routeType === '1' && returnPickupDateTime && dateTime) {
            if (returnPickupDateTime.isBefore(dateTime)) {
                setReturnDateError(true);
                setDateTimeError('Return pickup time cannot be earlier than initial pickup time');
            } else {
                setReturnDateError(false);
                setDateTimeError('');
            }
        } else {
            setReturnDateError(false);
            setDateTimeError('');
        }
    }, [returnPickupDateTime, dateTime, routeType]);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    // Using centralized Google Maps loader
    const { isLoaded, loadError } = useGoogleMapsLoader();

    const handleAllyProps = (event, newValue) => {
        setBookingTab(newValue);
    };

    const handleSubmit = async () => {
        console.log('wayPointArr = ', wayPointArr)
        // Compose waypointsArr: pickup, waypoints, drop
        const finalWaypoints = [];
        // Add pickup as first stop
        finalWaypoints.push({
            address: pickup,
            stop_id: 1,
            latitude: pickupLat,
            longitude: pickupLng
        });
        // Add all waypoints, incrementing stop_id
        wayPointArr.forEach((wp, idx) => {
            finalWaypoints.push({
                ...wp,
                stop_id: idx + 2 // pickup is 1
            });
        });
        // Add drop as last stop
        finalWaypoints.push({
            address: drop,
            stop_id: finalWaypoints.length + 1,
            latitude: dropLat,
            longitude: dropLng
        });
        // Add to payload after payload is defined
        // console.log('finalWaypoints', finalWaypoints);

            // Reset errors
        setPickupError('');
        setDropError('');
        // setDistanceError('');
        // setDurationError('');
        setDateTimeError('');
        setCustomerFirstNameError('');
        setCustomerLastNameError('');
        setCustomerCompanyNameError('');
        setCustomerEmailError('');
        setCustomerPhoneError('');
        setSeatsError('');
        setPriceError('');
        setMessage(''); // Clear previous snackbar messages
        setIsSubmitting(true); // Disable the save button

        let isValid = true;

        if (!pickup.trim()) {
            setPickupError('Pickup location is required.');
            isValid = false;
        }
        if (!drop.trim()) {
            setDropError('Drop location is required.');
            isValid = false;
        }
        // if (!distance.toString().trim()) {
        //     setDistanceError('Distance is required.');
        //     isValid = false;
        // }
        // if (!duration.toString().trim()) {
        //     setDurationError('Duration is required.');
        //     isValid = false;
        // }
        if (!dateTime) {
            setDateTimeError('Date and time are required.');
            isValid = false;
        }
        if (!customerFirstName.trim()) {
            setCustomerFirstNameError('Customer first name is required.');
            isValid = false;
        }
        // if (!customerCompanyName.trim()) {
        //     setCustomerCompanyNameError('Customer company name is required.');
        //     isValid = false;
        // }
        if (!customerEmail.trim()) {
            setCustomerEmailError('Customer email is required.');
            isValid = false;
        } else if (!isValidEmail(customerEmail)) {
            setCustomerEmailError('Invalid email format.');
            isValid = false;
        }
        if (!customerPhone.trim()) {
            setCustomerPhoneError('Phone number is required.');
            isValid = false;
        } else if (customerPhone.trim().length < 10) {
            setCustomerPhoneError('Phone number must be at least 10 digits.');
            isValid = false;
        }
        if (!seats.toString().trim()) {
            setSeatsError('Number of seats is required.');
            isValid = false;
        }
        if (!price.toString().trim()) {
            setPriceError('Price is required.');
            isValid = false;
        }
        if (!customerCompanyName.trim()) {
            setCustomerCompanyNameError('Customer company name is required.');
            isValid = false;
        }

        if (!isValid) {
        setMessage('Please fill in all required fields correctly.');
        showSnackbar(true);
        setIsSubmitting(false); // Re-enable the save button
        return;
        }

    //     if(distance==0){
    //     setMessage('Distance cannot be 0.');
    //     showSnackbar(true);
    //     setIsSubmitting(false); // Re-enable the save button
    //     return;
    // }

    //     if(duration==0){
    //     setMessage('Duration cannot be 0.');
    //     showSnackbar(true);
    //     setIsSubmitting(false); // Re-enable the save button
    //     return;
    // };

        if(seats==0){
        setMessage('Number of seats cannot be 0.');
        showSnackbar(true);
        setIsSubmitting(false); // Re-enable the save button
        return;
    };
    
    // Validate return pickup time for round trips
    if (routeType === '1' && returnPickupDateTime && dateTime) {
        if (returnPickupDateTime.isBefore(dateTime)) {
            setDateTimeError('Return pickup time cannot be earlier than pickup time');
            setReturnDateError(true);
            isValid = false;
            setIsSubmitting(false);
            return;
        }
    }

        // Use token from component scope
        let payload = {
            token: token,
            city_id: cityFilter
        };
        
        // If creating a new booking, include all fields
        if (!openEditModal) {
            // For new bookings, include all fields
            payload = {
                ...payload,
                pickup_address: pickup,
                pickup_latitude: pickupLat,
                pickup_longitude: pickupLng,
                drop_address: drop,
                drop_latitude: dropLat,
                drop_longitude: dropLng,
                user_email: customerEmail,
                user_phone_number: customerPhone,
                country_code: customerCountryCode,
                ticket_count: seats,
                pickup_time: dateTime ? dayjs(dateTime).format('YYYY-MM-DD HH:mm:ss') : null,
                // fare: price,
                user_first_name: customerFirstName,
                user_last_name: customerLastName,
                user_company_name: customerCompanyName,
                distance: distance,
                duration: duration,
                payment_mode: paymentMode,
                payment_status: paymentStatus,
                // self_remarks: selfRemark,
                // driver_remarks: driverRemark,
                source: -1,
                is_two_way: routeType,
                // tax : tax? tax : 0
            };
            
            // Add optional fields for new bookings
            if(driverRemark!=""){
                payload.driver_remarks = driverRemark;
            }
            if(selfRemark!=""){
                payload.self_remarks = selfRemark;
            }
            if (flightInfo) {
                payload.flight_number = flightInfo;
            }
            if (assignDriver.vehicle_make_id) {
                payload.vehicle_make_id = assignDriver.vehicle_make_id;
            }
            if (assignDriver.driver_id) {
                payload.driver_id = assignDriver.driver_id;
            }
            if(returnDriver.driver_id && routeType==1){
                payload.return_driver_id = returnDriver.driver_id;
            }
            if(returnDriver.vehicle_make_id && routeType==1){
                payload.return_vehicle_make_id = returnDriver.vehicle_make_id;
            }
            if (luggage) {
                payload.luggage_count = luggage;
            }
            if (tax) {
                payload.tax = ischange_point_to_comma == '1'? tax?.replace(/,/g, '.'): tax;
            }
            if(price) {
                payload.fare = ischange_point_to_comma == '1' ? String(price)?.replace(/,/g, '.') : price;
            }
            if(extras){
                payload.extra_fare = ischange_point_to_comma == '1' ? String(extras)?.replace(/,/g, '.') : extras;
            }
            if(partnerPrice){
                payload.partner_fare = ischange_point_to_comma == '1' ? String(partnerPrice)?.replace(/,/g, '.') : partnerPrice;
            }
            if(routeType==1){
                payload.return_pickup_time = returnPickupDateTime ? dayjs(returnPickupDateTime).format('YYYY-MM-DD HH:mm:ss') : null;   
            }
            if(noOfChildren){
                payload.no_of_childrens = noOfChildren;
            }
        } else {
            // For editing existing bookings, only include changed fields
            payload.booking_id = bookingId;
            
            // Compare current values with original values and only include changed fields
            if (pickup !== originalBookingData.pickup_address) {
                payload.pickup_address = pickup;
            }
            if (pickupLat !== originalBookingData.pickup_latitude) {
                payload.pickup_latitude = pickupLat;
            }
            if (pickupLng !== originalBookingData.pickup_longitude) {
                payload.pickup_longitude = pickupLng;
            }
            if (drop !== originalBookingData.drop_address) {
                payload.drop_address = drop;
            }
            if (dropLat !== originalBookingData.drop_latitude) {
                payload.drop_latitude = dropLat;
            }
            if (dropLng !== originalBookingData.drop_longitude) {
                payload.drop_longitude = dropLng;
            }
            if (customerEmail !== originalBookingData.user_email) {
                payload.user_email = customerEmail;
            }
            if (customerPhone !== originalBookingData.user_phone_number) {
                payload.user_phone_number = customerPhone;
            }
            if (customerCountryCode !== originalBookingData.country_code) {
                payload.country_code = customerCountryCode;
            }
            if (paymentMode !== originalBookingData.payment_mode) {
                payload.payment_mode = paymentMode;
            }
            if (paymentStatus !== originalBookingData.payment_status) {
                payload.payment_status = paymentStatus;
            }
            if (String(partnerPrice).replace(',','.') !== originalBookingData.partner_fare){
                payload.partner_fare = ischange_point_to_comma == '1'? String(partnerPrice).replace(/,/g, '.'): partnerPrice;
            }
            if (String(extras).replace(',','.') !== originalBookingData.extra_fare){
                payload.extra_fare = ischange_point_to_comma == '1'? String(extras).replace(/,/g, '.'): extras;
            }
            
            if (parseInt(seats) !== parseInt(originalBookingData.ticket_count)) {
                payload.ticket_count = seats;
            }
            
            const formattedDateTime = dateTime ? dayjs(dateTime).format('YYYY-MM-DD HH:mm:ss') : null;
            const originalDateTime = originalBookingData.pickup_time ? dayjs(originalBookingData.pickup_time).format('YYYY-MM-DD HH:mm:ss') : null;
            if (formattedDateTime !== originalDateTime) {
                payload.pickup_time = formattedDateTime;
            }
            
            if (parseFloat(String(price)?.replace(',', '.')) !== parseFloat(originalBookingData.fare)) {
                payload.fare = ischange_point_to_comma == '1' ? String(price)?.replace(/,/g, '.') : price;
            }
            if (customerFirstName !== originalBookingData.user_first_name) {
                payload.user_first_name = customerFirstName;
            }
            if (customerLastName !== originalBookingData.user_last_name) {
                payload.user_last_name = customerLastName;
            }
            if (customerCompanyName !== originalBookingData.user_company_name) {
                payload.user_company_name = customerCompanyName;
            }
            console.log('distance = ', distance)
            console.log('originalBookingData.distance = ', originalBookingData)
            if (parseFloat(distance) !== parseFloat(originalBookingData.distance)) {
                payload.distance = distance;
            }
            if (parseFloat(duration) !== parseFloat(originalBookingData.duration)) {
                payload.duration = duration;
            }
            // Handle no_of_childrens - convert empty strings to 0 for comparison
            const originalChildren = originalBookingData.no_of_childrens === "" || originalBookingData.no_of_childrens === null ? 0 : parseInt(originalBookingData.no_of_childrens);
            const currentChildren = noOfChildren === "" ? 0 : parseInt(noOfChildren);
            
            if (currentChildren !== originalChildren) {
                payload.no_of_childrens = noOfChildren === "" ? 0 : noOfChildren;
            }
            
            // Check if remarks have changed
            const remarksChanged = 
                selfRemark !== originalBookingData.self_remarks ||
                driverRemark !== originalBookingData.driver_remarks;
                
            if (remarksChanged) {
                payload.self_remarks = selfRemark;
                payload.driver_remarks = driverRemark;
            }
            
            // Add optional fields only if they've changed
            if (flightInfo !== originalBookingData.flight_number) {
                payload.flight_number = flightInfo;
            }
            
            if (assignDriver.vehicle_make_id && assignDriver.vehicle_make_id !== originalBookingData.vehicle_make_id) {
                payload.vehicle_make_id = assignDriver.vehicle_make_id;
            }
            
            if (assignDriver.driver_id && assignDriver.driver_id !== originalBookingData.driver_id) {
                payload.driver_id = assignDriver.driver_id;
            }

            if (returnDriver.vehicle_make_id && returnDriver.vehicle_make_id !== originalBookingData.vehicle_make_id) {
                payload.return_vehicle_make_id = returnDriver.vehicle_make_id;
            }
            
            if (returnDriver.driver_id && returnDriver.driver_id !== originalBookingData.driver_id) {
                payload.return_driver_id = returnDriver.driver_id;
            }
            
            // Handle luggage_count - convert empty strings to 0 for comparison
            const originalLuggage = originalBookingData.luggage_count === "" || originalBookingData.luggage_count === null ? 0 : parseInt(originalBookingData.luggage_count);
            const currentLuggage = luggage === "" ? 0 : parseInt(luggage);
            
            if (currentLuggage !== originalLuggage) {
                payload.luggage_count = luggage === "" ? 0 : luggage;
            }
            
            // Handle tax - convert empty strings to 0 for comparison
            const originalTax = originalBookingData.tax === "" || originalBookingData.tax === null ? 0 : parseFloat(originalBookingData.tax);
            const currentTax = tax === "" ? 0 : parseFloat(tax);
            
            if (currentTax !== originalTax) {
                payload.tax = tax === "" ? 0 : (ischange_point_to_comma == '1' ? String(tax).replace(/,/g, '.') : tax);
            }
        }

        // Attach waypointsArr to payload before sending
        if(wayPointArr.length) payload.way_points = finalWaypoints;
        else payload.way_points = [];

        try {
            const url = operationsUrl + '/airport/create_and_update_bookings';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                // console.log('message = ', response.message);
                const successMsg = response.message || 'Booking processed successfully.';
                handleClose();
                // Set message and show snackbar after modal is closed
                setTimeout(() => {
                    setMessage(successMsg);
                    showSnackbar(true);
                }, 100);
                fetchBookingsData();
            } else {
                setMessage(response.message || 'An error occurred processing the booking.')
                showSnackbar(true);
                setIsSubmitting(false); // Re-enable the save button
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error.message || 'An unexpected error occurred.');
            showSnackbar(true);
            setIsSubmitting(false); // Re-enable the save button
        }
    }

    // Function to calculate distance and duration using Directions API
    const calculateRoute = (origin, destination, waypoints = []) => {
        if (!origin || !destination || !window.google || !window.google.maps) return;
        
        const directionsService = new window.google.maps.DirectionsService();
        
        // Format waypoints for the directions API if they exist
        const formattedWaypoints = waypoints.map(wp => ({
            location: { lat: wp.latitude, lng: wp.longitude },
            stopover: true
        }));
        
        directionsService.route(
            {
                origin: { lat: origin.lat, lng: origin.lng },
                destination: { lat: destination.lat, lng: destination.lng },
                waypoints: formattedWaypoints,
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    console.log('Directions result:', result);
                    
                    // Get total distance in kilometers
                    const totalDistance = result.routes[0].legs.reduce(
                        (total, leg) => total + leg.distance.value, 0
                    ) / 1000; // Convert meters to kilometers
                    
                    // Get total duration in minutes
                    const totalDuration = Math.ceil(
                        result.routes[0].legs.reduce(
                            (total, leg) => total + leg.duration.value, 0
                        ) / 60 // Convert seconds to minutes
                    );
                    
                    console.log(`Calculated distance: ${totalDistance} km, duration: ${totalDuration} mins`);
                    
                    // Set the calculated values
                    setDistance(totalDistance.toFixed(2));
                    setDuration(totalDuration);
                } else {
                    console.error('Directions request failed due to ' + status);
                }
            }
        );
    };

    // Calculate route when both pickup and drop coordinates are available
    useEffect(() => {
        // Only recalculate route if:
        // 1. We're not in edit modal, OR
        // 2. We're in edit modal but locations have been modified
        // This prevents overwriting the original distance/duration when just opening the edit modal
        if (pickupLat && pickupLng && dropLat && dropLng && (!openEditModal || locationsModified)) {
            const origin = { 
                lat: parseFloat(pickupLat), 
                lng: parseFloat(pickupLng) 
            };
            const destination = { 
                lat: parseFloat(dropLat), 
                lng: parseFloat(dropLng) 
            };
            calculateRoute(origin, destination, wayPointArr);
        }
    }, [pickupLat, pickupLng, dropLat, dropLng, wayPointArr, openEditModal, locationsModified]);

    useEffect(() => {
        const loadAutocomplete = () => {
            if (window.google && window.google.maps && window.google.maps.places) {
                // Setup autocomplete for pickup location
                const pickupAutocomplete = new window.google.maps.places.Autocomplete(inputPickupRef.current, {
                    types: ['geocode', 'establishment']
                });
                pickupAutocomplete.addListener('place_changed', () => {
                    const place = pickupAutocomplete.getPlace();
                    if (place.geometry) {
                        const lat = place.geometry.location.lat();
                        const lng = place.geometry.location.lng();
                        
                        setPickup(place.formatted_address || '')
                        setPickupLat(lat)
                        setPickupLng(lng)
                        setLocationsModified(true) // Set flag when user selects a new location
                    }
                });
                
                // Setup autocomplete for drop location
                const dropAutocomplete = new window.google.maps.places.Autocomplete(inputDropRef.current, {
                    types: ['geocode', 'establishment']
                });
                dropAutocomplete.addListener('place_changed', () => {
                    const place = dropAutocomplete.getPlace();
                    if (place.geometry) {
                        const lat = place.geometry.location.lat();
                        const lng = place.geometry.location.lng();
                        
                        setDrop(place.formatted_address || '')
                        setDropLat(lat)
                        setDropLng(lng)
                        setLocationsModified(true) // Set flag when user selects a new drop location
                        
                        // If pickup is already set, calculate route
                        if (pickupLat && pickupLng) {
                            console.log('Drop location changed - recalculating route with current waypoints')
                            const origin = { 
                                lat: parseFloat(pickupLat), 
                                lng: parseFloat(pickupLng) 
                            };
                            const destination = { 
                                lat: parseFloat(lat), 
                                lng: parseFloat(lng) 
                            };
                            
                            // Get current waypoints state and calculate route with them
                            // This ensures we're using the most up-to-date waypoints
                            setWayPointArr(currentWaypoints => {
                                calculateRoute(origin, destination, currentWaypoints);
                                return currentWaypoints; // Return unchanged to avoid re-render
                            });
                        }
                    }
                });
                // Setup autocomplete for the single waypoint input
                if (waypointInputRef.current && !waypointInputRef.current._autocompleteAttached) {
                    const waypointAutocomplete = new window.google.maps.places.Autocomplete(waypointInputRef.current, 
                        { types: ['geocode', 'establishment'] }
                    );
                    waypointAutocomplete.addListener('place_changed', () => {
                        const place = waypointAutocomplete.getPlace();
                        if (place && place.geometry) {
                            const lat = place.geometry.location.lat();
                            const lng = place.geometry.location.lng();
                            const address = place.formatted_address || '';
                            if (!address || wayPointArr.some(wp => wp.address === address)) {
                                setWaypointInputValue('');
                                return;
                            }
                            const newWaypoint = {
                                address,
                                stop_id: wayPointArr.length + 1,
                                latitude: lat,
                                longitude: lng,
                                // arrived_at: new Date().toISOString()
                            };
                            setWayPointArr(arr => {
                                const updated = [...arr, newWaypoint];
                                // Always re-index stop_id
                                return updated.map((item, i) => ({ ...item, stop_id: i + 1 }));
                            });
                            setWaypointInputValue('');
                            setShowWaypointInput(false); // Hide input after adding waypoint
                            setLocationsModified(true) // Set flag when user adds a waypoint
                        }
                    });
                    waypointInputRef.current._autocompleteAttached = true;
                }
            }
            // Attach Google Places Autocomplete to each waypoint input
            if (window.google && window.google.maps && window.google.maps.places && waypointRefs.current) {
                wayPointArr.forEach((wp, idx) => {
                    const input = waypointRefs.current[idx];
                    if (input && !input._autocompleteAttached) {
                        const ac = new window.google.maps.places.Autocomplete(input, { types: ['geocode'] });
                        ac.addListener('place_changed', () => {
                            const place = ac.getPlace();
                            if (place && place.geometry) {
                                const lat = place.geometry.location.lat();
                                const lng = place.geometry.location.lng();
                                const address = place.formatted_address || '';
                                setWayPointArr(arr => arr.map((item, widx) =>
                                    widx === idx ? { ...item, address, latitude: lat, longitude: lng } : item
                                ));
                                setLocationsModified(true); // Set flag when user edits a waypoint
                            }
                        });
                        input._autocompleteAttached = true;
                    }
                });
            }
        };
        if (isLoaded) {
            loadAutocomplete();
        }
    }, [isLoaded, openAddModal, openEditModal, wayPointArr, showWaypointInput]);

    const exportCSV = () => {
        // Define which columns to include in the CSV
        const headers = [
            'Booking ID',
            'Booking Mode',
            'Source ID',
            'Customer Name',
            'Phone Number',
            'Email',
            'Company Name',
            'Pickup Address',
            'Drop Address',
            'Stops',
            'Pickup Time',
            'Number of Seats',
            'Number of Children',
            'Luggage Count',
            'Driver Name',
            'Driver Email',
            'Driver Phone Number',
            'Vehicle Number',
            'Distance',
            'Duration',
            'Fare',
            'Tax',
            'Partner Price',
            'Extra Price',
            'Total Fare',
            'Payment Mode',
            'Payment Status',
            'Flight Number',
            'Journey Code',
            'Parent Booking ID',
            'Booking Status',
            'Driver Remarks',
            'Self Remarks'
        ];

        const parseNum = val => {
            if (val === undefined || val === null || val === '') return 0;
            // Remove spaces, replace all commas with dots, remove all except digits, dot, minus
            let normalized = String(val).replace(/\s/g, '').replace(/,/g, '.').replace(/[^0-9.-]/g, '');
            // If there are multiple dots, keep only the first as decimal
            const parts = normalized.split('.');
            if (parts.length > 2) {
                normalized = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
            }
            const num = Number(normalized);
            return isNaN(num) ? 0 : num;
        };


        // Map the data rows to match the headers
        const csvData = rows.map(row => {
            const stopsString = row.way_points
            ? row.way_points
                .map((item, index) =>
                    (index !== 0 && index !== row.way_points.length - 1)
                        ? `${index}) ${item.address}`
                        : null
                )
                .filter(Boolean)
                .join('\n')
            : '';

            return [
                row.booking_id,
                row.source==1 ? 'PIU' : row.source==2 ? 'Transferz' : row.source==0 ? 'Others' : row.source==-1 ? 'Admin Panel' : 'Unknown',
                row.source_id,
                `${row.user_first_name || ''} ${row.user_last_name || ''}`,
                row.user_phone_number || '',
                row.user_email || '',
                row.user_company_name || '',
                row.pickup_address || '',
                row.drop_address || '',
                stopsString,
                row.pickup_time ? 
                  (() => {
                    const pickupDate = new Date(row.pickup_time);
                    // Add the offset minutes to the date
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                      day: '2-digit', 
                      month: '2-digit', 
                      year: 'numeric', 
                      hour: '2-digit', 
                      minute: '2-digit', 
                      hour12: timeZoneFormat == '12' ? true : false,
                      timeZone: 'UTC'
                    }).replace(',', ' |');
                  })() 
                  : '',
                row.ticket_count || '0',
                row.no_of_childrens || '0',
                row.luggage_count || '0',
                row.driver_name || '--',
                row.driver_email || '--',
                row.driver_phone || '--',
                row.vehicle_number || '--',
                row.distance || '0',
                row.duration || '0',
                row.fare || '0',
                row.tax || '0',
                row.partner_fare || '0',
                row.extra_fare || '0',
                (Number(row.fare) + Number(row.tax) + Number(row.partner_fare) + Number(row.extra_fare)) || '0',
                row.payment_mode==1 ? 'Cash' : row.payment_mode==2 ? 'Prepaid' : 'Unknown' || '',
                row.payment_status==0 ? 'Pending' : row.payment_status==1 ? 'Paid' : 'Unknown' || '',
                row.flight_number || '--',
                row.journey_code || '--',
                row.linked_booking_id || '--',
                row.booking_status==1 ? 'Pending' : row.booking_status==2 ? 'Accepted' : row.booking_status==3 ? 'Rejected' : row.booking_status==4 ? 'Missed' : row.booking_status==5 ? 'Cancelled' : row.booking_status==6 ? 'Assigned' : row.booking_status==7 ? 'Unassigned' : row.booking_status==8 ? 'Started' : row.booking_status==9 ? 'Ended' : row.booking_status==10 ? 'Cancelled' : row.booking_status==11 ? 'No Show' : row.booking_status==12 ? 'Arrived at Pickup' : 'Unknown',
                row.driver_remarks || '--',
                row.self_remarks || '--'
            ];

        });

        
        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        
        csvData.forEach(rowArray => {
            // Properly escape fields that might contain commas
            const formattedRow = rowArray.map(field => {
                // Convert to string and check if it needs quotes
                const stringField = String(field || '');
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    // Escape quotes and wrap in quotes
                    return `"${stringField.replace(/"/g, '""')}"`;  
                }
                return stringField;
            });
            csvContent += formattedRow.join(',') + '\n';
        });

        // Create a blob and download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        // Set up download attributes
        const date = new Date().toISOString().slice(0, 10);
        link.setAttribute('href', url);
        link.setAttribute('download', `requested_bookings_${date}.csv`);
        link.style.visibility = 'hidden';
        
        // Append to document, trigger download, and clean up
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    const fetchCustomersData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/fetch_all`;
            const obj={
                token: token, timestamp: timestamp
            }
            if(cityFilter) obj['city_id'] = cityFilter;

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            
            if(response.flag === 200){
                const customersData = response.data;
                setCustomersData(customersData);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setCustomersData([]);
        }
    };

    const formatDecimalsWithComma = (row) => {
    const decimalFields = [
     'fare','distance','tax','partner_fare','extra_fare',
    ];
    const formatted = { ...row };
    decimalFields.forEach(field => {
        if (
            formatted[field] !== undefined &&
            formatted[field] !== null &&
            typeof formatted[field] !== 'object' &&
            !isNaN(formatted[field]) &&
            String(formatted[field]).includes('.')
        ) {
            formatted[field] = String(formatted[field]).replace('.', ',');
        }
    });
    return formatted;
    };


    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Booking Management
            </Typography>

            <Grid2 item container spacing={0.5} xs={12} md={8} alignItems="flex-end" sx={{ marginTop: '1%', marginBottom: '2%' }}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'42px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item sx={{marginLeft:'1%'}}>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={startDateFilter}
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "MM/DD/YYYY"}
                            onChange={(newValue) => {
                                if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                    setEndDateFilter(null);
                                }
                                setStartDateFilter(newValue);
                                setTodayDate(false)
                                setUpcomingDate(false)
                            }}
                            maxDate={endDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%'}}>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "MM/DD/YYYY"}
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={endDateFilter}
                            onChange={(newValue) => {
                                setEndDateFilter(newValue)
                                setTodayDate(false)
                                setUpcomingDate(false)
                            }}
                            minDate={startDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Select value={bookingStatusFilter} 
                    onChange={(e) => setBookingStatusFilter(e.target.value)} displayEmpty
                    style={{width: '180px',height:'42px',borderRadius:'8px',backgroundColor: bookingStatusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Booking Status</MenuItem>
                        <MenuItem value="1">Pending</MenuItem>
                        <MenuItem value="2">Accepted</MenuItem>
                        <MenuItem value="3">Rejected</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item sx={{display:'flex', alignItems:'center', border:'1px solid #D1D5DB', borderRadius:'8px', padding:'2px 4px', backgroundColor:'#f9f9f9'}}>
                    <Typography>Today</Typography>
                    <Switch 
                        checked={todayDate} 
                        onChange={(e) => {
                            setTodayDate(e.target.checked)
                            if(e.target.checked){
                                setUpcomingDate(false)
                                setStartDateFilter(dayjs())
                                setEndDateFilter(dayjs())
                            }
                            else{
                                setUpcomingDate(false)
                                setStartDateFilter(dayjs().startOf('month').startOf('day'))
                                setEndDateFilter(dayjs().endOf('month').endOf('day'))
                            }
                        }} 
                        inputProps={{ 'aria-label': 'controlled' }} 
                    />
                </Grid2>

                <Grid2 item sx={{display:'flex', alignItems:'center', border:'1px solid #D1D5DB', borderRadius:'8px', padding:'2px 4px', backgroundColor:'#f9f9f9'}}>
                    <Typography>Upcoming Trips</Typography>
                    <Switch 
                        checked={upcomingDate} 
                        onChange={(e) => {
                            setUpcomingDate(e.target.checked)
                            if(e.target.checked){
                                setTodayDate(false)
                                setStartDateFilter(dayjs())
                                setEndDateFilter(dayjs().add(365, 'day'))
                            }
                            else{
                                setTodayDate(false)
                                setStartDateFilter(dayjs().startOf('month').startOf('day'))
                                setEndDateFilter(dayjs().endOf('month').endOf('day'))
                            }
                        }} 
                        inputProps={{ 'aria-label': 'controlled' }} 
                    />
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%'}}>
                    <Button
                        variant="contained" onClick={handleOpenAddBooking}
                        style={{width:'180px',height: '42px',backgroundColor:'#0065FF',textTransform:'none',borderRadius:'8px'}}>
                        + Create Booking
                    </Button>
                </Grid2>
                <Grid2 item sx={{marginLeft:'1%', marginLeft:'auto'}}>
                    <Label></Label><br/>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={exportCSV}
                        sx={{
                            height: '40px',
                            textTransform: 'none',
                            borderRadius: '8px',
                            backgroundColor: '#36C68F',
                            '&:hover': {
                                backgroundColor: '#36C68F',
                            },
                        }}
                    >
                        Export CSV
                    </Button>
                </Grid2>
            </Grid2>

            {(openAddModal || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '24px', marginTop: '8px', fontWeight: 'bold' }}>
                                    {openEditModal ? 'Edit Booking' : 'Add Booking'}
                                </Typography>

                                <Label>Customer Details<span style={{ color: 'red' }}>*</span></Label>
                                <Grid2 spacing={2} sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'2%', marginTop:'1%', marginBottom:'2%'}}>
                                    <Grid2 item>
                                        <Box sx={{ 
                                            position: 'relative',
                                            width: '100%',
                                            mt: 1,
                                            mb: 2
                                        }}>
                                            <TextField
                                                placeholder="Search by Company Name"
                                                fullWidth
                                                variant="outlined"
                                                value={customerCompanyNameFilter}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setCustomerCompanyNameFilter(value);
                                                    
                                                    // Filter customers based on company name
                                                    if (value && value.length > 1) {
                                                        // Filter by company_name (case insensitive)
                                                        const filtered = customersData.filter(customer => 
                                                            customer.company_name && 
                                                            customer.company_name.toLowerCase().includes(value.toLowerCase())
                                                        );
                                                        
                                                        // Keep all matching results, including duplicates
                                                        setFilteredCustomerCompanyName(filtered);
                                                        setShowCustomerCompanyNameResults(filtered.length > 0);
                                                    } else {
                                                        setFilteredCustomerCompanyName([]);
                                                        setShowCustomerCompanyNameResults(false);
                                                    }
                                                }}
                                                onBlur={() => {
                                                    setTimeout(() => setShowCustomerCompanyNameResults(false), 200);
                                                }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Box sx={{ mr: 1 }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <circle cx="11" cy="11" r="8"></circle>
                                                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                            </svg>
                                                        </Box>
                                                    ),
                                                    style: {height: '52px',borderRadius: '12px',fontSize: '16px',backgroundColor: '#f9f9f9'}
                                                }}
                                            />
                                            {showCustomerCompanyNameResults && filteredCustomerCompanyName.length > 0 && (
                                                <Box sx={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    mt: 1,
                                                    border: '1px solid #E5E7EB',
                                                    borderRadius: '8px',
                                                    maxHeight: '300px',
                                                    overflowY: 'auto',
                                                    backgroundColor: '#FFFFFF',
                                                    zIndex: 1000,
                                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)'
                                                }}>
                                                    {filteredCustomerCompanyName.map((customer, index) => (
                                                        <Box 
                                                            sx={{ 
                                                                p: 2, 
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                borderBottom: index < filteredCustomerCompanyName.length - 1 ? '1px solid #E5E7EB' : 'none',
                                                                cursor: 'pointer',
                                                                '&:hover': { backgroundColor: '#F9FAFB' }
                                                            }} 
                                                            key={index}
                                                            onClick={() => {
                                                                // Don't set customer details yet, only company name
                                                                setCustomerCompanyName(customer.company_name || '');
                                                                setCustomerCompanyNameFilter(customer.company_name || '');
                                                                // Filter customers with the same company name for the next search
                                                                const companyCustomers = customersData.filter(c => 
                                                                    c.company_name && c.company_name === customer.company_name
                                                                );
                                                                
                                                                setFilteredCustomerNames(companyCustomers);
                                                                setShowCustomerCompanyNameResults(false);

                                                                setCustomerFirstName(customer.user_name?.split(' ')[0] || '');
                                                                setCustomerLastName(customer.user_name?.split(' ')[1] || '');
                                                                setCustomerEmail(customer.user_email || '');
                                                                setCustomerPhone(customer.phone_number || '');
                                                                setCustomerNameFilter(customer.user_name || '');
                                                                
                                                                const getCountryCode = (phone) => {
                                                                    try {
                                                                        const parsed = parsePhoneNumber(phone);
                                                                        return parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '';
                                                                    } catch {
                                                                        return '';
                                                                    }
                                                                };
                                                                setCustomerCountryCode(getCountryCode(customer.phone_number || ''));
                                                                setShowCustomerNameResults(false);
                                                            }}
                                                        >
                                                            <Typography sx={{ fontWeight: 500, color:'#0065ff' }}><span style={{ fontWeight: 600, fontSize:'14px' }}>Company Name: </span>{customer.company_name}</Typography>
                                                            <Typography variant="body2" color="text.secondary"><span style={{ fontWeight: 600 }}>User Name: </span>{customer.user_name}</Typography>
                                                            <Typography variant="body2" color="text.secondary"><span style={{ fontWeight: 600 }}>Phone: </span>{customer.phone_number}</Typography>
                                                            {customer.user_email && <Typography variant="body2" color="text.secondary"><span style={{ fontWeight: 600 }}>Email: </span>{customer.user_email}</Typography>}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            )}
                                            {(filteredCustomerCompanyName.length === 0 && customerCompanyNameFilter.length>1) && (
                                                <Typography sx={{ color: '#D14545',textAlign:'right' }}>No companies found</Typography>
                                            )}
                                        </Box>
                                    </Grid2>

                                    <Grid2 container spacing={2} sx={{marginTop:'1%', display:'flex'}}>

                                        <Grid2 item size={12}>
                                            <Label>Customer Company Name<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'1%'}}
                                                placeholder="Company Name" fullWidth variant="outlined" type="text" 
                                                value={customerCompanyName}
                                                onChange={(e) => { 
                                                    const value = e.target.value;
                                                    setCustomerCompanyName(value);
                                                    
                                                    // Clear previous error
                                                    if (customerCompanyNameError) setCustomerCompanyNameError('');
                                                }}
                                                error={!!customerCompanyNameError}
                                                helperText={customerCompanyNameError}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <PersonIcon sx={{ color: '#666' }} />
                                                        </InputAdornment>
                                                    ),
                                                    inputProps: { min: 0 },
                                                    style: {height: '48px', fontSize: '16px', padding: '8px 14px',backgroundColor:'#fff', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid2>


                                        <Grid2 item size={12}>
                                            {customerCompanyName && (
                                                <Box sx={{ mt: 1 }}>
                                                    <TextField
                                                        placeholder="Search by Customer Name"
                                                        fullWidth
                                                        variant="outlined"
                                                        value={customerNameFilter}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setCustomerNameFilter(value);
                                                            
                                                            // Filter customers based on name within the selected company
                                                            if (value && value.length > 1) {
                                                                // Get all customers belonging to the selected company first
                                                                // const companyCustomers = customersData.filter(c => 
                                                                //     c.company_name && c.company_name === customerCompanyName
                                                                // );
                                                                
                                                                // Then filter by customer name
                                                                const filtered = customersData.filter(customer => 
                                                                    customer.user_name && 
                                                                    customer.user_name.toLowerCase().includes(value.toLowerCase())
                                                                );
                                                                
                                                                setFilteredCustomerNames(filtered);
                                                                setShowCustomerNameResults(true);
                                                            } else {
                                                                // Reset to all customers from the company if search is cleared
                                                                const companyCustomers = customersData.filter(c => 
                                                                    c.company_name && c.company_name === customerCompanyName
                                                                );
                                                                setFilteredCustomerNames(companyCustomers);
                                                                setShowCustomerNameResults(companyCustomers.length > 0);
                                                            }
                                                        }}
                                                        onBlur={() => {
                                                            setTimeout(() => setShowCustomerNameResults(false), 200);
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <SearchIcon />
                                                                </InputAdornment>
                                                            ),
                                                            style: {height: '52px',borderRadius: '12px',fontSize: '16px',backgroundColor: '#f9f9f9'}
                                                        }}
                                                    />
                                                    {showCustomerNameResults && filteredCustomerNames.length > 0 && (
                                                        <Box sx={{
                                                            position: 'absolute',
                                                            width: '100%',
                                                            maxHeight: '300px',
                                                            overflowY: 'auto',
                                                            backgroundColor: '#FFFFFF',
                                                            borderRadius: '8px',
                                                            border: '1px solid #E5E7EB',
                                                            mt: 1,
                                                            zIndex: 1000,
                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)'
                                                        }}>
                                                            {
                                                                filteredCustomerNames.map((customer, index) => (
                                                                <Box 
                                                                    sx={{ 
                                                                        p: 2, 
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        borderBottom: index < filteredCustomerNames.length - 1 ? '1px solid #E5E7EB' : 'none',
                                                                        cursor: 'pointer',
                                                                        '&:hover': { backgroundColor: '#F9FAFB' }
                                                                    }} 
                                                                    key={index}
                                                                    onClick={() => {
                                                                        setCustomerFirstName(customer.user_name?.split(' ')[0] || '');
                                                                        setCustomerLastName(customer.user_name?.split(' ')[1] || '');
                                                                        setCustomerEmail(customer.user_email || '');
                                                                        setCustomerPhone(customer.phone_number || '');
                                                                        setCustomerNameFilter(customer.user_name || '');
                                                                        
                                                                        const getCountryCode = (phone) => {
                                                                            try {
                                                                                const parsed = parsePhoneNumber(phone);
                                                                                return parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '';
                                                                            } catch {
                                                                                return '';
                                                                            }
                                                                        };
                                                                        setCustomerCountryCode(getCountryCode(customer.phone_number || ''));
                                                                        setShowCustomerNameResults(false);
                                                                    }}
                                                                >
                                                                    <Typography sx={{ fontWeight: 500, color:'#0065ff' }}>{customer.user_name}</Typography>
                                                                    <Typography variant="body2" color="text.secondary"><span style={{ fontWeight: 600 }}>Phone: </span>{customer.phone_number}</Typography>
                                                                    {customer.user_email && <Typography variant="body2" color="text.secondary"><span style={{ fontWeight: 600 }}>Email: </span>{customer.user_email}</Typography>}
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    )}
                                                    {(filteredCustomerNames.length === 0 && customerNameFilter.length > 1) && (
                                                        <Typography sx={{ color: '#D14545', textAlign: 'right' }}>No customer found</Typography>
                                                    )}
                                                </Box>
                                            )}
                                        </Grid2>

                                        <Grid2 item size={6}>
                                            <Label>Customer First Name<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'1%'}}
                                                placeholder="Customer First Name" fullWidth variant="outlined" type="text" 
                                                value={customerFirstName}
                                                onChange={(e) => { setCustomerFirstName(e.target.value); if (customerFirstNameError) setCustomerFirstNameError(''); }}
                                                error={!!customerFirstNameError}
                                                helperText={customerFirstNameError}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <PersonIcon sx={{ color: '#666' }} />
                                                        </InputAdornment>
                                                    ),
                                                    inputProps: { min: 0 },
                                                    style: {height: '48px', fontSize: '16px', padding: '8px 14px',backgroundColor:'#fff', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid2>

                                        <Grid2 item size={6}>
                                            <Label>Customer Last Name</Label>
                                            <TextField sx={{marginTop:'1%'}}
                                                placeholder="Customer Last Name" fullWidth variant="outlined" type="text" 
                                                value={customerLastName}
                                                onChange={(e) => { setCustomerLastName(e.target.value); if (customerLastNameError) setCustomerLastNameError(''); }}
                                                error={!!customerLastNameError}
                                                helperText={customerLastNameError}
                                                InputProps={{
                                                    inputProps: { min: 0 },
                                                    style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor:'#fff', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid2>
                                    </Grid2>

                                    <Grid2 container spacing={2} sx={{marginTop:'2%', display:'flex'}}>

                                        <Grid2 item size={6}>
                                            <Label>Customer Email<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'1%'}}
                                                placeholder="Enter Email" fullWidth variant="outlined" type="text" 
                                                value={customerEmail}
                                                onChange={(e) => { 
                                                    const value = e.target.value;
                                                    setCustomerEmail(value);
                                                    
                                                    // Clear previous error
                                                    if (customerEmailError) setCustomerEmailError('');
                                                    
                                                    // Validate email format if not empty
                                                    if (value && !validateEmail(value)) {
                                                        setCustomerEmailError('Please enter a valid email address');
                                                    }
                                                }}
                                                error={!!customerEmailError}
                                                helperText={customerEmailError}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <EmailIcon sx={{ color: '#666' }} />
                                                        </InputAdornment>
                                                    ),
                                                    inputProps: { min: 0 },
                                                    style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor:'#fff', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid2>
                                        <Grid2 item size={6}>
                                            <Label>Phone No.<span style={{ color: 'red' }}>*</span></Label>
                                            <div>
                                                <PhoneInput
                                                    defaultCountry="IN"
                                                    value={customerPhone}
                                                    onChange={(value) => {
                                                        setCustomerPhone(value);
                                                        // Clear error when user types
                                                        if (customerPhoneError) setCustomerPhoneError('');
                                                        
                                                        try {
                                                            const parsed = parsePhoneNumber(value);
                                                            if (parsed) {
                                                                setCustomerCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                            }
                                                        } catch (err) {
                                                            console.error('Invalid phone number:', err);
                                                            setCustomerCountryCode('');
                                                        }
                                                    }}
                                                    // placeholder="Enter phone number"
                                                    style={{
                                                        height: '44px',
                                                        fontSize: '18px',
                                                        alignItems: 'normal', 
                                                        marginTop:'2%',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#f9f9f9'
                                                    }}
                                                />
                                                {customerPhoneError && (
                                                    <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                                                        {customerPhoneError}
                                                    </Typography>
                                                )}
                                            </div>
                                        </Grid2>

                                    </Grid2>
                                </Grid2>

                                {!openEditModal && (
                                    <>      
                                        <Label>Select Route<span style={{ color: 'red' }}>*</span></Label>
                                        <Grid2 sx={{ marginBottom: '16px' }}>
                                            <FormControl fullWidth sx={{border:'1px solid #D1D5DB', borderRadius:'8px', marginTop:'1%'}}>
                                                <RadioGroup 
                                                    row
                                                    defaultValue=""
                                            name="controlled-radio-buttons-group"
                                            value={routeType}
                                            onChange={(e) => setRouteType(e.target.value)}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                gap: '24px'
                                            }}
                                        >
                                            <FormControlLabel 
                                                value="0" 
                                                control={<Radio />} 
                                                label="One Way"
                                                sx={{ margin: 0 }}
                                            />
                                            <FormControlLabel 
                                                value="1" 
                                                control={<Radio />} 
                                                label="Return"
                                                sx={{ marginLeft: '8%' }}
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                        </Grid2>
                                        
                                    </>
                                )}
                                
                                <Label>Enter Pickup & Drop Location<span style={{ color: 'red'}}>*</span></Label>
                                <Grid2 spacing={2} sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'2%', marginTop:'1%', marginBottom:'2%'}}>

                                    <Grid2 item sx={{ paddingTop:'0px'}}>
                                        <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'8px', paddingLeft:'8px', paddingBottom:'8px', marginTop:'1%', backgroundColor:'#fff'}}>
                                            <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                                <img src={pickupMarker} style={{width:'30px',height:'30px',marginTop:'2%'}}/>
                                                <input ref={inputPickupRef} type="text" placeholder=" Search Pickup Location" className="filterBtn"
                                                    style={{
                                                        width:'80%', marginTop:'2%', marginLeft:'2%', border:'1px solid #D1D5DB',
                                                        backgroundPosition: '8px center'
                                                    }}
                                                    value={pickup}
                                                    onChange={(e) => { setPickup(e.target.value); if (pickupError) setPickupError(''); }}
                                                />
                                            </Grid2>
                                            {pickupError && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>{pickupError}</Typography>}
                                            
                                            {/* Render added waypoints above the input */}


{/* Render added waypoints as before */}
{wayPointArr.length > 0 && wayPointArr.map((wp, idx) => (
    <Grid2 key={wp.stop_id} item sx={{display:'flex', alignItems:'center', marginTop: '2%'}}>
        <span style={{
            display: 'inline-block',
            minWidth: 24,
            minHeight: 24,
            borderRadius: '50%',
            background: '#2A313C',
            color: '#fff',
            fontWeight: 500,
            textAlign: 'center',
            lineHeight: '24px',
            marginRight: 8
        }}>{idx + 1}</span>
        <input
            ref={el => waypointRefs.current[idx] = el}
            type="text"
            value={wp.address}
            placeholder={"Stop " + (idx + 1)}
            className="filterBtn"
            style={{ flex: 1, marginLeft: '2%', marginRight: '2%', height: '48px', fontSize: '14px', padding: '0px 14px', borderRadius: 8, border: '1px solid #D1D5DB' }}
            onChange={e => {
                const newAddress = e.target.value;
                setWayPointArr(arr => arr.map((item, widx) =>
                    widx === idx ? { ...item, address: newAddress, latitude: '', longitude: '' } : item
                ));
            }}
        />
        <img src={SubtractCircleSvg} onClick={() => {
            setWayPointArr(arr => {
                const filtered = arr.filter(item => item.stop_id !== wp.stop_id);
                // Re-index stop_id to always be contiguous
                return filtered.map((item, i) => ({ ...item, stop_id: i + 1 }));
            });
            setLocationsModified(true); // Set flag when user removes a waypoint
        }} style={{width:'28px',height:'28px', marginRight:'2%', cursor:'pointer'}}/>
    </Grid2>
))}

{showWaypointInput && (
    <Grid2 item sx={{display:'flex', alignItems:'center',  marginTop:'2%'}}>
        <span style={{
            display: 'inline-block',
            minWidth: 24,
            minHeight: 24,
            borderRadius: '50%',
            background: '#2A313C',
            color: '#fff',
            fontWeight: 500,
            textAlign: 'center',
            lineHeight: '24px',
            marginRight: 8
        }}>{wayPointArr.length + 1}</span>
        <input
            ref={waypointInputRef}
            type="text"
            placeholder={"Stop " + (wayPointArr.length + 1)}
            className="filterBtn"
            style={{
                width: '79.5%', marginLeft: '2%',marginRight:'2%',
                backgroundPosition: '8px center', border:'1px solid #D1D5DB'
            }}
            value={waypointInputValue}
            onChange={e => setWaypointInputValue(e.target.value)}
        />
        <img onClick={() => setShowWaypointInput(false)} src={SubtractCircleSvg} style={{width:'28px',height:'28px', cursor:'pointer'}}/>
    </Grid2>
)}


                                            <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                                <img src={dropMarker} style={{width:'30px',height:'30px',marginTop:'2%'}}/>
                                                <input ref={inputDropRef} type="text" placeholder=" Search Drop Location" className="filterBtn"
                                                    style={{
                                                        width:'80%', marginTop:'2%', marginLeft:'2%', border:'1px solid #D1D5DB',
                                                        backgroundPosition: '8px center'
                                                    }}
                                                    value={drop}
                                                    onChange={(e) => { setDrop(e.target.value); if (dropError) setDropError(''); }}
                                                />
                                                <img onClick={() => {
                                                    if(wayPointArr.length >= 3){
                                                        setShowWaypointInput(false)
                                                        setMessage('You can add a maximum of three stops.')
                                                        showSnackbar(true)
                                                    }
                                                    else{
                                                        setShowWaypointInput(true)
                                                    }
                                                }} 
                                                src={AddCircleSvg} style={{width:'28px',height:'28px',marginTop:'2%', cursor:'pointer'}}/>
                                            </Grid2>
                                            {dropError && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>{dropError}</Typography>}
                                        </Grid2>
                                        
                                    </Grid2>

                                    <Grid2 item sx={{marginTop:'2%'}}>
                                        <Label>Distance (in km)<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Distance (in km)" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                            value={distance ? String(distance).replace(".",",") : ''}  disabled                                            // onChange={(e) => { 
                                            //     // Only set non-negative values
                                            //     const value = e.target.value;
                                            //     if (ischange_point_to_comma === '1') {
                                            //         if (value === '' || /^[0-9,]+$/.test(value)) {
                                            //             setDistance(value);
                                            //             if (durationError) setDistanceError('');
                                            //         }}
                                            //     else {if (value === '' || parseFloat(value) >= 0) {
                                            //         setDistance(value);
                                            //         if (priceError) setDistanceError('');
                                            //     }}
                                            // }}
                                            // error={!!distanceError}
                                            // helperText={distanceError}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item container size={12} spacing={2} sx={{display:'flex', marginTop:'2%'}}>
                                        <Grid2 item size={6}>
                                            <Label>Duration (in minutes)<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'2%'}}
                                                placeholder="Duration" variant="outlined" type="number" 
                                                value={duration} fullWidth disabled
                                                // onChange={(e) => { 
                                                //     // Only set non-negative values
                                                //     const value = e.target.value;
                                                //     if (value === '' || parseFloat(value) >= 0) {
                                                //         setDuration(value);
                                                //         if (durationError) setDurationError('');
                                                //     }
                                                // }}
                                                // error={!!durationError}
                                                // helperText={durationError}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <AccessTimeFilledIcon sx={{ color: '#666' }} />
                                                        </InputAdornment>
                                                    ),
                                                    inputProps: { min: 0 },
                                                    style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid2>

                                        <Grid2 item size={6}>
                                            <Label>Select Date & Time<span style={{ color: 'red' }}>*</span></Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer
                                                    components={['DateTimePicker']}
                                                    sx={{
                                                        '& .MuiStack-root': {
                                                            padding: 0
                                                        }
                                                    }}
                                                >
                                                    <DateTimePicker
                                                        sx={{
                                                            width: '100%',
                                                            '& .MuiOutlinedInput-root': {
                                                                height: '48px',
                                                                borderRadius: '8px',
                                                                backgroundColor: '#FFFFFF',
                                                                border: returnDateError ? '1px solid red' : 'none',
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '16px',
                                                                padding: '0px 14px',
                                                                color: returnDateError ? 'red' : 'inherit',
                                                            }
                                                        }}
                                                        value={dateTime}
                                                        onChange={(newValue) => { setDateTime(newValue); if (dateTimeError) setDateTimeError(''); }}
                                                        format={date_format_dd_mm_yy ? "DD-MM-YYYY HH:mm" : "YYYY-MM-DD HH:mm"}
                                                        ampm={false}
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                placeholder: 'Select date and time'
                                                            }
                                                        }}
                                                    />
                                                    {dateTimeError && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>{dateTimeError}</Typography>}
                                                </DemoContainer>
                                            </LocalizationProvider>
                                            
                                        </Grid2>
                                    </Grid2>

                                </Grid2>
                                <Grid2 item sx={{ display: routeType === '1' ? 'block' : 'none', marginBottom: '16px' }} >
                                    <Label>Return Pickup Date & Time<span style={{ color: 'red' }}>*</span></Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer
                                            components={['DateTimePicker']}
                                            sx={{
                                                '& .MuiStack-root': {
                                                    padding: 0
                                                }
                                            }}
                                        >
                                            <DateTimePicker
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        height: '48px',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#FFFFFF',
                                                        border: returnDateError ? '1px solid red' : 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '16px',
                                                        padding: '0px 14px',
                                                        color: returnDateError ? 'red' : 'inherit',
                                                    }
                                                }}
                                                value={returnPickupDateTime}
                                                onChange={(newValue) => { setReturnPickupDateTime(newValue); }}
                                                format={date_format_dd_mm_yy ? "DD-MM-YYYY HH:mm" : "YYYY-MM-DD HH:mm"}
                                                ampm={false}
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        placeholder: 'Select date and time'
                                                    }
                                                }}
                                            />
                                            {dateTimeError && <Typography color="error" variant="caption" sx={{ display: 'block', mt:0.5}}>{dateTimeError}</Typography>}
                                        </DemoContainer>
                                    </LocalizationProvider>
                                    
                                </Grid2>

                                <Grid2 container spacing={2} sx={{marginTop:'2%', display:'flex'}}>

                                    <Grid2 item size={6}>
                                        <Label>Number of seats<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Number of seats" fullWidth variant="outlined" type="number" 
                                            value={seats}
                                            onChange={(e) => { 
                                                // Only set non-negative values
                                                const value = e.target.value;
                                                if (value === '' || /^\d+$/.test(value)) {
                                                    setSeats(value);
                                                    if (seatsError) setSeatsError('');
                                                }
                                            }}
                                            error={!!seatsError}
                                            helperText={seatsError}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <img src={blackSeatIcon} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item size={6}>
                                        <Label>Number of Children</Label>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Number of Children" fullWidth variant="outlined" type="number" 
                                            value={noOfChildren}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Handle empty input
                                                if (value === '') {
                                                    setNoOfChildren(value);
                                                    return;
                                                }
                                                
                                                // Check if value is non-negative
                                                if (parseFloat(value) < 0) {
                                                    return; // Don't update for negative values
                                                }
                                                
                                                // Check if value exceeds seats
                                                if (parseInt(value) > parseInt(seats || 0)) {
                                                    // Temporarily set the value to show the error
                                                    setNoOfChildren(value);
                                                    return;
                                                }
                                                
                                                // If we get here, the value is valid
                                                setNoOfChildren(value);
                                            }}
                                            error={noOfChildren !== '' && parseInt(noOfChildren) > parseInt(seats || 0)}
                                            helperText={noOfChildren !== '' && parseInt(noOfChildren) > parseInt(seats || 0) ? 'Number of children cannot exceed total seats' : ''}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>
                                    
                                </Grid2>

                                <Typography sx={{marginTop:'3%', fontSize:'18px', fontWeight:'500'}}>
                                    Payments<span style={{ color: 'red' }}>*</span>
                                </Typography>

                                <Grid2>
                                    <Typography sx={{color:'#83888E', marginTop:'2%'}}>Payment Mode</Typography>
                                    <Select sx={{marginTop:'1%'}}
                                        value={paymentMode} 
                                        fullWidth
                                        onChange={(e) => {  
                                            const newPaymentMode = e.target.value;
                                            if (newPaymentMode === 2 || newPaymentMode === "2") {
                                                setPaymentStatus(1);
                                            } else{
                                                setPaymentStatus(0);
                                            }
                                            setPaymentMode(e.target.value);
                                        }}
                                        style={{ height: '48px', borderRadius: '8px', backgroundColor: '#f9f9f9'}}>
                                        <MenuItem value="1">Cash</MenuItem>
                                        <MenuItem value="2">Prepaid</MenuItem>
                                    </Select>
                                </Grid2>

                                <Grid2 item sx={{backgroundColor: '#F9F9F9', alignItems:'center', display:'flex', marginTop:'2%', padding:'2%', borderRadius:'8px'}}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={paymentStatus === 1} 
                                                onChange={(e) => {
                                                    setPaymentStatus(e.target.checked ? 1 : 0);
                                                }} 
                                            />
                                        }
                                        label="Paid"
                                    />
                                </Grid2>

                                <Grid2 container spacing={2}>
                                    <Grid2 item size={6}>
                                        <Typography sx={{color:'#83888E', marginTop:'2%'}}>Price<span style={{ color: 'red' }}>*</span></Typography>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Price" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                            value={price}
                                            onChange={(e) => { 
                                                // Only set non-negative values
                                                const value = e.target.value;
                                                if (ischange_point_to_comma === '1') {
                                                    if (value === '' || /^[0-9]{1,}(,[0-9]{0,2})?$/.test(value)) {
                                                        setPrice(value);
                                                        if (priceError) setPriceError('');
                                                    }}
                                                else {if (value === '' || /^[0-9]{1,}(,[0-9]{0,2})?$/.test(value)) {
                                                    setPrice(value);
                                                    if (priceError) setPriceError('');
                                                }}
                                            }}
                                            error={!!priceError}
                                            helperText={priceError}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>
                                    
                                    <Grid2 item size={6}>
                                        <Typography sx={{color:'#83888E', marginTop:'2%'}}>Tax</Typography>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Tax" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                            value={tax}
                                            onChange={(e) => {
                                                // Only set non-negative values
                                                const value = e.target.value;
                                                if (ischange_point_to_comma === '1') {
                                                    if (value === '' || /^[0-9]{1,}(,[0-9]{0,2})?$/.test(value)) {
                                                        setTax(value);
                                                    }}
                                                else {if (value === '' || /^[0-9]{1,}(,[0-9]{0,2})?$/.test(value)) {
                                                    setTax(value);
                                                }}
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>
                                </Grid2>

                                <Grid2 container spacing={2}>
                                    <Grid2 item size={6}>
                                        <Typography sx={{color:'#83888E', marginTop:'2%'}}>Extras</Typography>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Extras" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                            value={extras}
                                            onChange={(e) => { 
                                                const value = e.target.value;
                                                if (ischange_point_to_comma === '1') {
                                                    if (value === '' || /^[0-9]{1,}(,[0-9]{0,2})?$/.test(value)) {
                                                        setExtras(value);
                                                    }}
                                                else {if (value === '' || /^[0-9]{1,}(,[0-9]{0,2})?$/.test(value)) {
                                                    setExtras(value);
                                                }}
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>
                                    
                                    <Grid2 item size={6}>
                                        <Typography sx={{color:'#83888E', marginTop:'2%'}}>Partner Price</Typography>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Partner Price" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                            value={partnerPrice}
                                            onChange={(e) => {
                                                // Only set non-negative values
                                                const value = e.target.value;
                                                if (ischange_point_to_comma === '1') {
                                                    if (value === '' || /^[0-9]{1,}(,[0-9]{0,2})?$/.test(value)) {
                                                        setPartnerPrice(value);
                                                    }}
                                                else {if (value === '' || /^[0-9]{1,}(,[0-9]{0,2})?$/.test(value)) {
                                                    setPartnerPrice(value);
                                                }}
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>
                                </Grid2>

                                {!openEditModal &&
                                    <Grid2 spacing={2} sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'2%', marginBottom:'4%', marginTop:'2%'}}>
                                        <Grid2 sx={{marginTop:'2%'}}>
                                            <Label>Assign Driver</Label>
                                            <Select sx={{marginTop:'1%'}}
                                                value={assignDriver.driver_id} 
                                                fullWidth
                                                onChange={(e) => {
                                                    const selectedDriver = driversData.find(driver => driver.driver_id === e.target.value);
                                                    setAssignDriver({
                                                        driver_id: selectedDriver.driver_id,
                                                        vehicle_make_id: selectedDriver.vehicle_make_id || '',
                                                        model_name: selectedDriver.model_name || '', 
                                                        vehicle_number: selectedDriver.vehicle_number || ''
                                                    });
                                                }}
                                                style={{ height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                {driversData && driversData.map((driver) => (
                                                    <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                                        {driver.driver_name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid2>
                                    
                                        <Grid2  sx={{marginTop:'2%'}}>
                                            <Label>Select Vehicle</Label>
                                            <Select sx={{marginTop:'1%'}}
                                                value={editVehicleMakeId || assignDriver.vehicle_make_id || ''} 
                                                fullWidth
                                                onChange={(e) => {
                                                    const selectedId = e.target.value;
                                                    setEditVehicleMakeId(selectedId);
                                                    
                                                    // Find the selected vehicle and update assignDriver
                                                    const selectedVehicle = vehicleMakeData.find(vehicle => 
                                                        vehicle.vehicle_make_id === selectedId || vehicle.id === selectedId);
                                                    if (selectedVehicle) {
                                                        // Update assignDriver with the new vehicle info
                                                        setAssignDriver(prev => ({
                                                            ...prev,
                                                            vehicle_make_id: selectedVehicle.vehicle_make_id || selectedVehicle.id,
                                                            model_name: selectedVehicle.model_name || '', 
                                                            vehicle_number: selectedVehicle.vehicle_number || ''
                                                        }));
                                                    }
                                                }}
                                                style={{ height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                <MenuItem value="">Select a vehicle</MenuItem>
                                                {vehicleMakeData && vehicleMakeData.map((vehicleMake) => (
                                                    <MenuItem key={vehicleMake.id || vehicleMake.vehicle_make_id} 
                                                            value={vehicleMake.id || vehicleMake.vehicle_make_id}>
                                                        {vehicleMake.vehicle_number}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid2>
                                    </Grid2>
                                }

                                {(!openEditModal && routeType==1) &&
                                    <Grid2 item container size={12} sx={{ marginTop:'2%'}}>
                                        <Grid2 item size={4}>
                                            <Typography sx={{marginTop:'1%'}}>Same data for return trip</Typography>
                                        </Grid2>
                                        <Grid2 item size={1}><Typography sx={{marginLeft:'4%', marginTop:'6%'}}>:</Typography></Grid2>
                                        <Grid2 item size={6}>
                                            <Switch checked={isReturnDriverVehicleSame} 
                                            onChange={(e) => {
                                                setIsReturnDriverVehicleSame(e.target.checked)
                                                if(e.target.checked==true){
                                                    setReturnDriver(assignDriver)
                                                    setReturnVehicleMakeData(editVehicleMakeId || assignDriver.vehicle_make_id || '')
                                                }
                                                else{
                                                    setReturnDriver({driver_id: '', vehicle_make_id: '', model_name: '', vehicle_number: ''})
                                                    setReturnVehicleMakeData('')
                                                }
                                                
                                            }} 
                                            inputProps={{ 'aria-label': 'controlled' }} />
                                        </Grid2>
                                    </Grid2>
                                }

                                {(!openEditModal && routeType==1) && 
                                    <Grid2 spacing={2} sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'2%', marginBottom:'4%'}}>
                                        {!openEditModal && 
                                            <Grid2>
                                                <Label>Assign Driver</Label>
                                                <Select sx={{marginTop:'1%'}}
                                                    value={returnDriver.driver_id} 
                                                    fullWidth
                                                    onChange={(e) => {
                                                        const selectedDriver = driversData.find(driver => driver.driver_id === e.target.value);
                                                        setReturnDriver({
                                                            driver_id: selectedDriver.driver_id,
                                                            vehicle_make_id: selectedDriver.vehicle_make_id || '',
                                                            model_name: selectedDriver.model_name || '', 
                                                            vehicle_number: selectedDriver.vehicle_number || ''
                                                        });
                                                    }}
                                                    style={{ height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                    {driversData && driversData.map((driver) => (
                                                        <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                                            {driver.driver_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid2>
                                        }

                                        {!openEditModal && 
                                            <Grid2  sx={{marginTop:'2%'}}>
                                                <Label>Select Vehicle</Label>
                                                <Select sx={{marginTop:'1%'}}
                                                    value={returnVehicleMakeData || returnDriver.vehicle_make_id || ''} 
                                                    fullWidth
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        setReturnVehicleMakeData(selectedId);
                                                        
                                                        // Find the selected vehicle and update assignDriver
                                                        const selectedVehicle = vehicleMakeData.find(vehicle => 
                                                            vehicle.vehicle_make_id === selectedId || vehicle.id === selectedId);
                                                        if (selectedVehicle) {
                                                            // Update assignDriver with the new vehicle info
                                                            setReturnDriver(prev => ({
                                                                ...prev,
                                                                vehicle_make_id: selectedVehicle.vehicle_make_id || selectedVehicle.id,
                                                                model_name: selectedVehicle.model_name || '', 
                                                                vehicle_number: selectedVehicle.vehicle_number || ''
                                                            }));
                                                        }
                                                    }}
                                                    style={{ height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                    <MenuItem value="">Select a vehicle</MenuItem>
                                                    {vehicleMakeData && vehicleMakeData.map((vehicleMake) => (
                                                        <MenuItem key={vehicleMake.id || vehicleMake.vehicle_make_id} 
                                                                value={vehicleMake.id || vehicleMake.vehicle_make_id}>
                                                            {vehicleMake.vehicle_number}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid2>
                                        }
                                    </Grid2>
                                }

                                <Grid2 container spacing={2} sx={{marginTop:'2%'}}>
                                    <Grid2 item size={6}>
                                        <Label>Luggage Count</Label>
                                        <TextField sx={{marginTop:'2%'}}
                                            placeholder="Luggage" fullWidth variant="outlined" type="number" 
                                            value={luggage}
                                            onChange={(e) => {
                                                // Only set non-negative values
                                                const value = e.target.value;
                                                if (value === '' || /^\d+$/.test(value)) {
                                                    setLuggage(value);
                                                }
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <img src={bagIcon} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item size={6}>
                                        <Label>Add Flight Number</Label>
                                        <TextField sx={{marginTop:'2%'}}
                                            placeholder="Flight Info" fullWidth variant="outlined" type="text" 
                                            value={flightInfo}
                                            onChange={(e) => setFlightInfo(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <img src={flightIcon} />
                                                    </InputAdornment>
                                                ),
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>
                                </Grid2>

                                <Grid2 item size={6} sx={{marginTop:'2%'}}>
                                    <Label>Self Remark</Label>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Remark" fullWidth variant="outlined" type="text" 
                                        value={selfRemark}
                                        onChange={(e) => setSelfRemark(e.target.value)}
                                        InputProps={{
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid2>

                                <Grid2 item xs={12} sm={12} sx={{marginTop:'2%'}}>
                                    <Label>Driver Remark</Label>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Driver Remark" fullWidth variant="outlined" type="text" 
                                        value={driverRemark}
                                        onChange={(e) => setDriverRemark(e.target.value)}
                                        InputProps={{
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid2>

                            </Paper>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'10%' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    disabled={isSubmitting}
                                    sx={{width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: isSubmitting ? '#90CAF9' : '#0065FF',color: 'white'}}>
                                    {isSubmitting ? 'Saving...' : (openEditModal ? 'Update' : 'Save')}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleClose}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#F0F0F0',
                                        color: '#B0B0B0',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>

                        </div>
                    </Box>
                </div>
            )}
            
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <AppBar position="static" color="default" elevation={0} sx={{backgroundColor:'#2A313C', borderRadius:'12px 12px 0 0'}}>
                        <Tabs
                        value={bookingTab}
                        onChange={handleAllyProps}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="booking tabs"
                        sx={{
                            '& .MuiTabs-indicator': {
                                height: '3px',
                                width: '100%'
                            }
                        }}
                        >
                        <StyledTab label={<TabWithBadge label="All Bookings" count={rows.length} isActive={bookingTab === 0} />} {...a11yProps(0)} />
                        <StyledTab label={<TabWithBadge label="PIU" count={piuCount} isActive={bookingTab === 1} />} {...a11yProps(1)} />
                        <StyledTab label={<TabWithBadge label="Transferz" count={transferzCount} isActive={bookingTab === 2} />} {...a11yProps(2)} />
                        <StyledTab label={<TabWithBadge label="Others" count={othersCount} isActive={bookingTab === 3} />} {...a11yProps(3)} />
                        <StyledTab label={<TabWithBadge label="Admin Panel" count={adminPanelCount} isActive={bookingTab === 4} />} {...a11yProps(4)} />
                        </Tabs>
                    </AppBar>
                </Box>
                
                <CustomTabPanel value={bookingTab} index={0}>
                    <BookingTable 
                        rows={(bookingStatusFilter 
                            ? rows.filter(row => row.booking_status == bookingStatusFilter) 
                            : rows).map(ischange_point_to_comma == '1' ? formatDecimalsWithComma : (row) => row)
                        } 
                        onEditBooking={handleOpenEditBooking} 
                        onFetchData={fetchBookingsData} 
                        driversData={driversData} 
                        vehicleMakeData={vehicleMakeData} 
                    />
                </CustomTabPanel>
                <CustomTabPanel value={bookingTab} index={1}>
                    <BookingTable 
                        rows={(bookingStatusFilter 
                            ? rows.filter(row => row.source === 1 && row.booking_status == bookingStatusFilter) 
                            : rows.filter(row => row.source === 1)).map(ischange_point_to_comma == '1' ? formatDecimalsWithComma : (row) => row)
                        } 
                        onEditBooking={handleOpenEditBooking} 
                        onFetchData={fetchBookingsData} 
                        driversData={driversData} 
                        vehicleMakeData={vehicleMakeData} 
                    />
                </CustomTabPanel>
                <CustomTabPanel value={bookingTab} index={2}>
                    <BookingTable 
                        rows={(bookingStatusFilter 
                            ? rows.filter(row => row.source === 2 && row.booking_status == bookingStatusFilter) 
                            : rows.filter(row => row.source === 2)).map(ischange_point_to_comma == '1' ? formatDecimalsWithComma : (row) => row)
                        } 
                        onEditBooking={handleOpenEditBooking} 
                        onFetchData={fetchBookingsData} 
                        driversData={driversData} 
                        vehicleMakeData={vehicleMakeData} 
                    />
                </CustomTabPanel>
                <CustomTabPanel value={bookingTab} index={3}>
                    <BookingTable 
                        rows={(bookingStatusFilter 
                            ? rows.filter(row => row.source === 0 && row.booking_status == bookingStatusFilter) 
                            : rows.filter(row => row.source === 0)).map(ischange_point_to_comma == '1' ? formatDecimalsWithComma : (row) => row)
                        } 
                        onEditBooking={handleOpenEditBooking} 
                        onFetchData={fetchBookingsData} 
                        driversData={driversData} 
                        vehicleMakeData={vehicleMakeData} 
                    />
                </CustomTabPanel>
                <CustomTabPanel value={bookingTab} index={4}>
                    <BookingTable 
                        rows={(bookingStatusFilter 
                            ? rows.filter(row => row.source === -1 && row.booking_status == bookingStatusFilter) 
                            : rows.filter(row => row.source === -1)).map(ischange_point_to_comma == '1' ? formatDecimalsWithComma : (row) => row)
                        } 
                        onEditBooking={handleOpenEditBooking} 
                        onFetchData={fetchBookingsData} 
                        driversData={driversData} 
                        vehicleMakeData={vehicleMakeData} 
                    />
                </CustomTabPanel>
            </Box>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default Booking;